import UserList from "./pages/ListPage.vue";
import UserDetail from "./pages/FormPage.vue";
import UserIndex from "./pages/IndexPage.vue";

export default [
    {
        path: "/user",
        component: UserIndex,
        redirect: "/user/list",
        name: "user",
        children: [
            {
                path: "list",
                component: UserList,
                name: "user.list",
            },
            {
                path: "create",
                component: UserDetail,
                name: "user.create",
                props: { create: true },
            },
            {
                path: "edit/:id",
                component: UserDetail,
                name: "user.edit",
                props: { create: false },
            },
        ],
    },
];
